import XmlValidator from './XmlValidator.vue';

export default [
  {
    path: '/xml-validator',
    name: 'xml-validator',
    component: XmlValidator,
  },
];
